module.exports = __webpack_public_path__ + "img/logo-cpn-residence-family-app.f64f5523.svg";